/**
 * LibraryRecentStrip — Feb 2026.
 *
 * Tiny "Recently added" shortcut strip rendered above each Library
 * pane (Lessons & Units / Summative / Classroom Support / Individual
 * Student Plans). Shows up to three of the most-recently-created
 * items as compact chips so a teacher can resume their last unit /
 * summative / plan in one click — without scrolling through folders
 * or paginated lists.
 *
 * Hides itself entirely when `items` is empty.
 *
 * Item shape (normalised by the parent pane):
 *   { id, title, subtitle?, dateLabel?, href }
 */
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function LibraryRecentStrip({ items = [], testid = "library-recent-strip" }) {
  const list = (items || []).slice(0, 3);
  if (list.length === 0) return null;
  return (
    <div className="mb-4" data-testid={testid}>
      <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#4a6984]/70 mb-2 px-1">
        Recently added
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {list.map((it) => (
          <Link
            key={it.id}
            to={it.href}
            data-testid={`${testid}-item-${it.id}`}
            className="ae-card p-3 min-w-0 hover:shadow-sm hover:-translate-y-0.5 transition group"
          >
            <div className="flex items-start justify-between gap-2">
              <p className="font-extrabold text-[#1c2d3d] text-sm truncate group-hover:text-[#2a7d6b] transition">
                {it.title}
              </p>
              <ArrowUpRight className="h-3.5 w-3.5 text-[#4a6984]/50 group-hover:text-[#2a7d6b] flex-shrink-0 mt-0.5" />
            </div>
            {it.subtitle && (
              <p className="text-xs text-[#4a6984]/70 truncate mt-0.5">{it.subtitle}</p>
            )}
            {it.dateLabel && (
              <p className="text-[10px] font-bold uppercase tracking-wide text-[#4a6984]/55 mt-1.5">
                {it.dateLabel}
              </p>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}
